// extracted by mini-css-extract-plugin
module.exports = {"bidNowButton":"BidNowButton_bidNowButton__s7IrD","root":"BidNowButton_root___ZtS6","cartButton":"BidNowButton_cartButton__cSwRj","icon":"BidNowButton_icon__6e2K6"};